export default {
  independentMarketing: {
    common: {
      requestFailed: 'Interface request failed',
      hintSelect: 'Select',
      hintInput: 'Enter',
      submit: 'Submit',
      cancel: 'Cancel',
      confirm: 'OK',
    },
    agreement: {
      title: 'Autel Independent Dealer Registration Agreement',
      nextBtn: 'Next',
      getAgreementFailed: 'Failed to get agreement content.',
    },
    successPage: {
      title:
        'Your application information has been successfully submitted and the review results will be sent to your email $1 within 15 working days. Please check your inbox for more information.',
      subTitle: 'Return to the home page after $1 second(s).',
    },
    applyTitle:
      'You are applying to become an Autel independent dealer. Please fill in the following information accurately:',
    companyName: 'Company name',
    companyTax: 'VAT ID',
    userCountry: 'Country',
    legalPerson: 'Legal counsel',
    contactEmail: 'Contact email',
    contactEmailTips:
      'This email address will be your contact the review result email. Once the review is approved, it will also be used as the login account name for the independent dealer management system.',
    corporateIdentity: 'Legal counsel ID',
    uploadTips: 'JPG, JPEG, PNG, PDF (no larger than 20 MB)',
    businessLicense: 'Business license',
    emailErrorTips: 'Enter a valid email.',
    uploadPic: 'Upload images',
    picMaxLimit: 'The maximum image size is 20 MB. Please select again.',
  },
};
